const ROUTE_TITLES: Record<string, string> = {
  dashboard: 'Dashboard',
  reports: 'Reports',
  'pos-payment-channels': 'POS Payment Channels',
  sales: 'Sales',
  'stock-correction-sales': 'Sales Stock Corrections',
  'restaurant-sales': 'Restaurant Sales',
  purchases: 'Purchase',
  'stock-correction-purchases': 'Purchase Stock Corrections',
  'stock-transfers': 'Stock Transfer',
  products: 'Product',
  inventories: 'Inventory',
  returns: 'Returns',
  damages: 'Damage Goods',
  warehouses: 'Warehouses',
  clients: 'Clients',
  suppliers: 'Suppliers',
  tags: 'Tags',
  categories: 'Categories',
  templates: 'Templates',
  'measurement-units': 'Measurement Units',
  expenses: 'Expenses',
  roles: 'Roles',
  users: 'Users',
  accounts: 'Accounts',
  'product-make': 'Make',
  'restaurant-pos': 'Restaurant POS',
  pos: 'POS',
  kitchen: 'Kitchen',
  staff: 'Staff',
  settings: 'Settings',
  'activity-history': 'Activity History',
};

const PREFIX_TITLES: Array<{ prefix: string; title: string }> = [
  { prefix: '/expenses/expense-categories', title: 'Expense Categories' },
  { prefix: '/warehouses/', title: 'Warehouses' },
  { prefix: '/accounts/show/', title: 'Accounts' },
];

const getFirstPathSegment = (pathname: string) => {
  const segments = pathname.split('/');
  const firstSegment = segments.find((segment) => segment.length > 0);
  return firstSegment || '';
};

const formatFallbackTitle = (value: string) => {
  const words = value.split('-');
  const formattedWords = words
    .filter((word) => word.length > 0)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1));

  return formattedWords.join(' ');
};

export const getRouteTitle = (pathname: string) => {
  const normalizedPath = pathname.replace(/\/+$/, '') || '/';

  if (normalizedPath === '/') return 'Dashboard';
  if (normalizedPath.startsWith('/inventories/show/')) return 'Inventory History';
  if (normalizedPath.startsWith('/warehouses/') && normalizedPath.endsWith('/products')) {
    return 'Warehouse Products';
  }

  const matchedPrefix = PREFIX_TITLES.find(
    ({ prefix }) => normalizedPath === prefix || normalizedPath.startsWith(prefix),
  );
  if (matchedPrefix) return matchedPrefix.title;

  const firstSegment = getFirstPathSegment(normalizedPath);
  if (!firstSegment) return '';

  return ROUTE_TITLES[firstSegment] || formatFallbackTitle(firstSegment) || '';
};
